export const NAVBAR_HEIGHT = 52;
export const NAVBAR_MOBILE_WIDTH = 312;
export const NAVBAR_DESKTOP_PADDING = 32;

export const MENU_ITEM_MOBILE_HORIZONTAL_PADDING = 24;
export const MENU_ITEM_DESKTOP_HORIZONTAL_PADDING = 20;

export const LOGO_LINK = "/portal";
